import async from 'components/Async';
import PageRouteUtil from 'routes/util';
import { path as AdUnitFormPagePath } from './AdManagerPage/AdUnitFormPage';
import { access } from '../../constants';

const AdManagerPage = async(() => import('./AdManagerPage'));
const EditSponsoredPartnerPage = async(() => import('./EditSponsoredPartnerPage'));
const PITRawDataPage = async(() => import('./PITRawDataPage'));
const ReportingPage = async(() => import('./ReportingPage'));
const AdUnitFormPage = async(() => import('./AdManagerPage/AdUnitFormPage'));

const syndicatedSponsoredAdsRouteList = [
   {
      path: '/syndicated-sponsored-ads/ad-manager',
      component: AdManagerPage,
   },
   {
      path: AdUnitFormPagePath,
      component: AdUnitFormPage,
   },
   {
      path: '/syndicated-sponsored-ads/edit-sponsored-partner',
      component: EditSponsoredPartnerPage,
      access: access.byRole.partner.onlyAdmin,
   },
   {
      path: '/syndicated-sponsored-ads/pit-raw-data',
      component: PITRawDataPage,
   },
   {
      path: '/syndicated-sponsored-ads/reporting',
      component: ReportingPage,
   },
];

export default PageRouteUtil.getPageRouteListHavingDefaultProperties(syndicatedSponsoredAdsRouteList);
